import { Controller } from "@hotwired/stimulus"
import { enter, leave, toggle } from "el-transition"

export default class extends Controller {
  // to use something other than `hidden` for the css class:
  //   add this to the element `data-reveal-hidden-class="invisible"`
  static targets = [ "item" ]
  static classes = [ "hidden" ]
   static values = {
    class: String
  }

  connect() {
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden"
  }

  toggle() {
    //console.log("toggle")
    this.itemTargets.forEach((item) => {
      toggle(item)
      //toggle(item.classList.toggle(this.class))
    })
  }

  show() {
    this.itemTargets.forEach((item) => {
      enter(item)
      //console.log(item)
      //toggle(item.classList.remove(this.class))
    })
  }

  hide() {
    //console.log("hide")
    this.itemTargets.forEach((item) => {
      leave(item)
      //toggle(item.classList.add(this.class))
    })
  }
}
